import styled from 'styled-components';

export const StyledDiv = styled.div`
line-height: 1.21428571em;
padding: 0.67857143em 1em;
`
export const InputWrapper = styled.div`
display: flex; 
align-items: center;
justify-content: center;
width: 100%;
 .loaderWrapper {
  position: relative; 
  margin: auto;
  margin-left: 10px; 
  margin-top: 23px; 
  margin-right: 5px;
 }
 .field {
  width: inherit !important;
 }
`